<script lang="ts" setup>
import ProductSpecialButton from '~/components/products/ProductSpecialButton.vue'
import ProductText from '~/components/products/ProductText.vue'
import type { ProductVariation } from '~/types/products'

defineProps<{
  variations: ProductVariation[]
}>()

const route = useRoute()
</script>

<template>
  <div v-if="variations.length">
    <div class="space-y-4">
      <div
        v-for="{ attributeId, attributeName, values } in variations"
        :key="attributeId"
        class="border-b border-gray-100 pb-3 last:border-b-0 last:pb-0"
      >
        <ProductText class="!mb-2 md:!mb-3" :text="attributeName" />

        <div class="flex flex-wrap">
          <ProductSpecialButton
            v-for="{ attributeValue, productPath } in values"
            :key="productPath"
            class="mb-2 mr-2 last:mr-0"
            :is-active="route.path === productPath"
            :title="attributeValue"
            @click.prevent="navigateTo(productPath)"
          />
        </div>
      </div>
    </div>
  </div>
</template>
